// extracted by mini-css-extract-plugin
export default {"GalleryPhotoOrigin__label":"ban_a bik_j bik_eb bik_i bik_so bik_sp bik_bi bik_bl","GalleryPhotoOrigin__reviewLink":"ban_b bik_j bik_eb bik_i bik_so bik_sp bik_bi bik_bo"};